(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-dinnerware-set"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
      this.querySelectorAll('a[data-value]').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      this.onOutsideClick = event => { if (!this.contains(event.target)) this.hidePanel(); };
    }

    connectedCallback() { document.addEventListener('click', this.onOutsideClick); }
    disconnectedCallback() { document.removeEventListener('click', this.onOutsideClick); }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.hidden = true;
    }

    onContainerKeyDown(event) {
      const { button, panel } = this.elements;
      if (event.key === 'Escape' && !panel.hidden) {
        event.preventDefault();
        event.stopPropagation();
        this.hidePanel();
        button.focus();
        return;
      }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      const items = Array.from(panel.querySelectorAll('a[data-value]'));
      if (!items.length || (panel.hidden && event.target !== button)) return;
      event.preventDefault();
      const current = items.indexOf(document.activeElement);
      let index;
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = items.length - 1;
      else if (current < 0) {
        const selected = items.findIndex(item => item.getAttribute('aria-current') === 'true');
        index = selected >= 0 ? selected : (event.key === 'ArrowUp' ? items.length - 1 : 0);
      } else index = (current + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
      panel.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      items[index].focus();
      items[index].scrollIntoView({ block: 'nearest' });
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      const form = this.querySelector('form');
      if (form) form.submit();
    }

    openSelector() {
      const { button, panel } = this.elements;
      panel.hidden = !panel.hidden;
      button.setAttribute('aria-expanded', String(!panel.hidden));
    }

    closeSelector(event) {
      if (event.relatedTarget) {
        if (!this.contains(event.relatedTarget)) this.hidePanel();
      } else {
        setTimeout(() => { if (!this.contains(document.activeElement)) this.hidePanel(); }, 0);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
      }, 300));
    }
  }

  if (!customElements.get('cart-note')) {
    customElements.define('cart-note', CartNote);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() { super(); }
    hide() { super.hide(); }
    show(opener) { super.show(opener); this.showActiveMedia(); }
    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalize-coasters"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() { super(); }
    hide() { super.hide(); }
    show(opener) { super.show(opener); this.showActiveMedia(); }
    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalize-magnets"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() { super(); }
    hide() { super.hide(); }
    show(opener) { super.show(opener); this.showActiveMedia(); }
    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalize-tiles"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() { super(); }
    hide() { super.hide(); }
    show(opener) { super.show(opener); this.showActiveMedia(); }
    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const tthProductRecommendationsCss = (() => {
    let loaded = false;

    return (csv) => {
      if (loaded || !csv) return;
      loaded = true;

      csv
        .split(',')
        .map((part) => part.trim().replace(/^"|"$/g, ''))
        .filter(Boolean)
        .forEach((href) => {
          if (document.querySelector(`link[data-tth-pr-css][href="${href}"]`)) return;

          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = href;
          link.setAttribute('data-tth-pr-css', '1');
          document.head.appendChild(link);
        });
    };
  })();

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.loaded = false;
    }

    connectedCallback() {
      const stripSeeSimilarFromPdpRecommendations = (root) => {
        if (!root) return;

        root.querySelectorAll('.js-tth-more-like-this, .tth-more-btn').forEach((el) => el.remove());
        root.querySelectorAll('#tth-card-rec-modal, .tth-card-rec-modal').forEach((el) => el.remove());
        root.querySelectorAll('.tth-actions').forEach((el) => el.classList.add('tth-actions--single'));
      };

      stripSeeSimilarFromPdpRecommendations(this);

      // Collective rows are rendered from their dedicated category on the server.
      // Keep the same native card/quick-add runtime without asking Shopify for
      // unrelated best-seller fallback recommendations.
      if (this.dataset.tthCollectiveRendered === 'true' && this.querySelector('[data-tth-collective-related]')) {
        tthProductRecommendationsCss(this.dataset.css || '');
        this.loaded = true;
        this.classList.add('is-loaded');
        this.setAttribute('data-tth-recommendations-settled', 'true');
        this.dispatchEvent(new CustomEvent('tth:recommendations:settled'));
        return;
      }

      const loadRecommendations = () => {
        if (this.loaded) return;
        this.loaded = true;

        const url = this.dataset.url;
        if (!url) return;

        tthProductRecommendationsCss(this.dataset.css || '');

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              stripSeeSimilarFromPdpRecommendations(recommendations);
              this.innerHTML = recommendations.innerHTML;
              stripSeeSimilarFromPdpRecommendations(this);
              this.classList.add('is-loaded');
            } else {
              this.innerHTML = '';
              this.classList.add('is-empty');
            }

            this.setAttribute('data-tth-recommendations-settled', 'true');
            this.dispatchEvent(new CustomEvent('tth:recommendations:settled'));
          })
          .catch(() => {
            this.innerHTML = '';
            this.classList.add('is-error');
            this.setAttribute('data-tth-recommendations-settled', 'true');
            this.dispatchEvent(new CustomEvent('tth:recommendations:settled'));
          });
      };

      const startDesktopRecommendations = () => {
        const run = () => loadRecommendations();

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(run, { timeout: 900 });
        } else {
          window.setTimeout(run, 120);
        }
      };

      if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) {
        if (document.readyState === 'complete') {
          startDesktopRecommendations();
        } else {
          window.addEventListener('load', startDesktopRecommendations, { once: true });
        }
      } else if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          loadRecommendations();
        }, { rootMargin: '220px 0px', threshold: 0.01 });

        observer.observe(this);
      } else {
        window.addEventListener('load', loadRecommendations, { once: true });
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  /* Exact product-card quick-add behavior for dynamically loaded PDP recommendations. */
  (function(){
        if (window.__tthUnifiedCardQuickAddReady) return;
        window.__tthUnifiedCardQuickAddReady = true;
  
        var modal = document.getElementById('tth-quick-add-modal');
        if (!modal) return;
  
        var content = modal.querySelector('[data-qp-content]');
        var cache = new Map();
        var activeTrigger = null;
        var scrollY = 0;
  
        function escapeHTML(value){
          return String(value || '').replace(/[&<>'"]/g, function(char){
            return ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'})[char];
          });
        }
  
        function lockScroll(){
          scrollY = window.scrollY || window.pageYOffset || 0;
          document.body.style.position = 'fixed';
          document.body.style.top = '-' + scrollY + 'px';
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.width = '100%';
          document.body.classList.add('tth-card-quick-add-active');
        }
  
        function unlockScroll(){
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          document.body.style.right = '';
          document.body.style.width = '';
          document.body.classList.remove('tth-card-quick-add-active');
          window.scrollTo(0, scrollY || 0);
        }
  
        function openModal(){
          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden', 'false');
          lockScroll();
        }
  
        function closeModal(){
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          unlockScroll();
          if (activeTrigger) {
            try { activeTrigger.focus({preventScroll:true}); } catch(error) {}
          }
          activeTrigger = null;
        }
  
        function closeNativeNotification(){
          document.querySelectorAll('cart-notification').forEach(function(notification){
            notification.classList.remove('is-active');
            notification.removeAttribute('open');
          });
          document.querySelectorAll('.tth-atc.is-open').forEach(function(fallback){
            fallback.classList.remove('is-open');
          });
        }
  
        function sectionURL(trigger){
          var url = new URL(trigger.getAttribute('data-product-url') || ('/products/' + trigger.getAttribute('data-handle')), window.location.origin);
          url.searchParams.set('section_id', 'quick-pick');
          return url.pathname + url.search;
        }
  
        function fetchPicker(trigger){
          var key = trigger.getAttribute('data-handle');
          if (cache.has(key)) return cache.get(key);
          var request = fetch(sectionURL(trigger), {credentials:'same-origin'})
            .then(function(response){
              if (!response.ok) throw new Error('HTTP ' + response.status);
              return response.text();
            })
            .then(function(html){
              var holder = document.createElement('div');
              holder.innerHTML = html;
              var picker = holder.querySelector('#quick-add');
              if (!picker) throw new Error('Quick Pick section not found');
              return picker.outerHTML;
            });
          cache.set(key, request);
          request.catch(function(){ cache.delete(key); });
          return request;
        }
  
        function renderSingle(trigger){
          var rawTitle = trigger.getAttribute('data-product-title') || ''; var fullTitle = escapeHTML(rawTitle); var title = escapeHTML(rawTitle.split('|')[0].trim() || rawTitle);
          var image = escapeHTML(trigger.getAttribute('data-product-image'));
          var price = escapeHTML(trigger.getAttribute('data-product-price'));
          var productURL = escapeHTML(trigger.getAttribute('data-product-url'));
          var variantId = escapeHTML(trigger.getAttribute('data-variant-id'));
  
          content.innerHTML = '' +
            '<div id="quick-add" class="qp-product" data-product-handle="' + escapeHTML(trigger.getAttribute('data-handle')) + '">' +
              '<div class="qp-product__layout">' +
                '<a class="qv-media qp-product__media" href="' + productURL + '" aria-label="View ' + fullTitle + '">' +
                  (image ? '<img src="' + image + '" alt="' + fullTitle + '" width="720" height="720" loading="eager" decoding="async">' : '') +
                '</a>' +
                '<div class="qp-product__info">' +
                  '<div class="qp-product__heading">' +
                    '<p class="qp-product__eyebrow">Adding to your cart</p>' +
                    '<h2 class="qv-title qp-product__title" aria-label="' + fullTitle + '"><a href="' + productURL + '" aria-label="' + fullTitle + '">' + title + '</a></h2>' +
                  '</div>' +
                  '<div class="qp-product__price"><div class="price"><span class="price__current">' + price + '</span></div></div>' +
                  '<div class="qp-product__actions">' +
                    '<button id="qp-add" type="button" class="button button--full-width product-form__submit qp-product__add" data-variant-id="' + variantId + '" disabled><span>Adding to cart…</span></button>' +
                    '<a class="qp-product__details" href="' + productURL + '">View full product details <span aria-hidden="true">→</span></a>' +
                  '</div>' +
                  '<div class="qp-product__success" data-qp-success hidden>' +
                    '<div class="qp-product__success-title">Added to cart</div>' +
                    '<a class="qp-product__cart-link" href="/cart">View my cart (<span data-qp-cart-count>0</span>)</a>' +
                    '<button type="button" class="qp-product__continue" data-qp-continue>Continue Shopping</button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>';
        }
  
        function renderLoading(){
          content.innerHTML = '<div class="qp-product__loading">Loading product options…</div>';
        }
  
        function formatMoney(cents, currency){
          try {
            return new Intl.NumberFormat(undefined, {style:'currency', currency:currency || 'USD'}).format(Number(cents || 0) / 100);
          } catch(error) {
            return '$' + (Number(cents || 0) / 100).toFixed(2);
          }
        }
  
        function selectedVariant(root){
          var json = root.querySelector('#qp-variants-json');
          if (!json) return null;
          var variants;
          try { variants = JSON.parse(json.textContent || '[]'); } catch(error) { return null; }
          var values = Array.from(root.querySelectorAll('.qp-select')).map(function(select){ return select.value; });
          if (!values.length) return variants.find(function(variant){ return variant.available; }) || variants[0] || null;
          return variants.find(function(variant){
            return values.every(function(value, index){ return variant.options[index] === value; });
          }) || null;
        }
  
        function syncVariant(root){
          var variant = selectedVariant(root);
          var add = root.querySelector('#qp-add');
          var price = root.querySelector('#qp-price');
          if (!variant || !add) return;
  
          add.setAttribute('data-variant-id', variant.id);
          add.disabled = !variant.available;
          var label = add.querySelector('span');
          if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
  
          if (price) {
            var currency = price.getAttribute('data-currency') || 'USD';
            var current = formatMoney(variant.price, currency);
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              price.innerHTML = '<div class="price"><s class="price__compare">' + formatMoney(variant.compare_at_price, currency) + '</s><span class="price__current">' + current + '</span></div>';
            } else {
              price.innerHTML = '<div class="price"><span class="price__current">' + current + '</span></div>';
            }
          }
        }
  
  
        function showError(root, message){
          var old = root.querySelector('.qp-product__error');
          if (old) old.remove();
          var actions = root.querySelector('.qp-product__actions');
          if (!actions) return;
          var error = document.createElement('div');
          error.className = 'qp-product__error';
          error.textContent = message || 'Something went wrong. Please try again.';
          actions.appendChild(error);
        }
  
        function showSuccess(root, cartCount){
          root.classList.add('is-added');
          var eyebrow = root.querySelector('.qp-product__eyebrow');
          if (eyebrow) eyebrow.textContent = 'Item added to your cart';
          var options = root.querySelector('.qp-product__options');
          var actions = root.querySelector('.qp-product__actions');
          var success = root.querySelector('[data-qp-success]');
          if (options) options.hidden = true;
          if (actions) actions.hidden = true;
          if (success) {
            success.hidden = false;
            var count = success.querySelector('[data-qp-cart-count]');
            if (count) count.textContent = String(cartCount || 0);
          }
          closeNativeNotification();
        }
  
        function addItem(root, variantId){
          var add = root.querySelector('#qp-add');
          var label = add ? add.querySelector('span') : null;
          if (add) add.disabled = true;
          if (label) label.textContent = 'Adding to cart…';
  
          return fetch('/cart/add.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            credentials:'same-origin',
            body:JSON.stringify({id:Number(variantId), quantity:1})
          })
          .then(function(response){
            if (!response.ok) return response.json().catch(function(){ return {}; }).then(function(payload){ throw new Error(payload.description || 'Unable to add this item.'); });
            return response.json();
          })
          .then(function(){ return fetch('/cart.js', {credentials:'same-origin'}); })
          .then(function(response){ if (!response.ok) throw new Error('Unable to refresh cart.'); return response.json(); })
          .then(function(cart){
            showSuccess(root, cart.item_count);
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
            window.setTimeout(closeNativeNotification, 0);
            window.setTimeout(closeNativeNotification, 250);
            return cart;
          })
          .catch(function(error){
            if (add) add.disabled = false;
            if (label) label.textContent = 'Add to cart';
            showError(root, error.message || 'Something went wrong. Please try again.');
            throw error;
          });
        }
  
        function handleTrigger(trigger){
          activeTrigger = trigger;
          closeNativeNotification();
          openModal();
  
          var hasVariants = trigger.getAttribute('data-has-variants') === 'true';
          if (!hasVariants) {
            renderSingle(trigger);
            var root = content.querySelector('#quick-add');
            addItem(root, trigger.getAttribute('data-variant-id')).catch(function(){});
            return;
          }
  
          renderLoading();
          fetchPicker(trigger)
            .then(function(html){
              content.innerHTML = html;
              var root = content.querySelector('#quick-add');
              if (root) syncVariant(root);
            })
            .catch(function(){
              content.innerHTML = '<div class="qp-product__loading">We could not load the options. <a href="' + escapeHTML(trigger.getAttribute('data-product-url')) + '">View the product instead.</a></div>';
            });
        }
  
        function preload(trigger){
          if (!trigger || trigger.getAttribute('data-has-variants') !== 'true') return;
          fetchPicker(trigger).catch(function(){});
        }
  
        document.addEventListener('pointerover', function(event){
          preload(event.target.closest('.js-card-pick-open'));
        }, true);
        document.addEventListener('focusin', function(event){
          preload(event.target.closest('.js-card-pick-open'));
        }, true);
        document.addEventListener('touchstart', function(event){
          preload(event.target.closest('.js-card-pick-open'));
        }, {capture:true, passive:true});
  
        document.addEventListener('click', function(event){
          var trigger = event.target.closest('.js-card-pick-open');
          if (!trigger) return;
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          handleTrigger(trigger);
        }, true);
  
        modal.addEventListener('click', function(event){
          var close = event.target.closest('[data-qp-close]');
          if (close) {
            event.preventDefault();
            event.stopPropagation();
            closeModal();
            return;
          }
  
          var continueButton = event.target.closest('[data-qp-continue]');
          if (continueButton) {
            event.preventDefault();
            event.stopPropagation();
            closeModal();
            return;
          }
  
  
          var add = event.target.closest('#qp-add');
          if (add) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            if (add.disabled) return;
            var root = add.closest('#quick-add');
            var variant = selectedVariant(root);
            var variantId = variant ? variant.id : add.getAttribute('data-variant-id');
            addItem(root, variantId).catch(function(){});
          }
        }, true);
  
        modal.addEventListener('change', function(event){
          if (!event.target.matches('.qp-select')) return;
          var root = event.target.closest('#quick-add');
          if (root) syncVariant(root);
        });
  
        document.addEventListener('keydown', function(event){
          if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
        });
      })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tth-collective-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() { super(); }
    hide() { super.hide(); }
    show(opener) { super.show(opener); this.showActiveMedia(); }
    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tth-complementary-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tth-complementary-products')) {
    customElements.define('tth-complementary-products', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.source !== 'shopify' || this.loaded) return;
        this.observer?.disconnect();
        const load = async () => {
          if (this.loaded) return;
          this.loaded = true;
          this.observer?.disconnect();
          try {
            const response = await fetch(this.dataset.url);
            if (!response.ok) throw new Error('Recommendations unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = html.querySelector('tth-complementary-products .tth-complementary__content');
            if (content && this.isConnected) {
              this.replaceChildren(content);
              this.hidden = false;
            }
          } catch (error) {
            this.hidden = true;
          }
        };
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) load();
          }, { rootMargin: '250px' });
          this.observer.observe(this.parentElement);
        } else {
          load();
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-guide-all"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() { super(); }
    hide() { super.hide(); }
    show(opener) { super.show(opener); this.showActiveMedia(); }
    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
